module.exports = __webpack_public_path__ + "static/media/Close.de2a3515.svg";